<template>
  <hr class="my-8" />
  <div class="md:w-[825px] mx-auto mt-5" v-if="projects">
    <div>
      <header class="flex items-center justify-between mb-4" v-if="projects">
        <p class="mt-2 font-light">New Projects in Ghana</p>
      </header>

      <vue-horizontal
        responsive
        class="horizontal"
        :displacement="0.7"
        snap="center"
      >
        <div class="flex space-x-3">
          <a
            :href="
              $router.resolve({
                name: 'ProjectView',
                params: {
                  id: project.id,
                  slug: project.title ? $sanitizeTitle(project.title) : '',
                },
              }).href
            "
            class="flex flex-col items-start w-56 p-2 border border-gray-300 rounded-md"
            v-for="project in projects"
            :key="project.id"
          >
            <div class="pb-2 text-start">
              <p class="text-[10px] font-light uppercase">New project</p>
              <p class="mt-2 text-sm font-semibold" v-if="project.company">
                {{ project.company.name }}
              </p>
            </div>

            <div class="max-w-[300px] max-h-[300px] overflow-hidden rounded-md">
              <img
                :src="project.photos[0]"
                class="object-cover w-56 h-40 transition duration-500 cursor-pointer hover:scale-110"
                alt=""
              />
            </div>

            <div class="flex flex-col w-full mt-2">
              <div class="p-1 bg-gray-100">
                <p class="text-sm font-light text-center text-gray-500">
                  Developer
                </p>
                <p
                  class="text-sm font-semibold text-center"
                  v-if="project.company"
                >
                  {{ project.company.name }}
                </p>
              </div>
              <div
                class="p-1 mt-2 text-center bg-gray-100"
                v-if="project.delivery_date"
              >
                <p class="text-sm font-light text-gray-500">Delivery Date</p>
                <p class="text-sm font-semibold">
                  {{ getQuarterWithYear(project.delivery_date) }}
                </p>
              </div>
            </div>
          </a>
        </div>
      </vue-horizontal>
      <div class="flex justify-center mt-5" v-if="projects.length > 6">
        <button
          class="p-2 mt-4 font-semibold text-center bg-transparent border rounded-lg w-80 border-primary text-primary texp"
        >
          See all New Projects
        </button>
      </div>
      <hr class="mt-5" />
    </div>
  </div>
</template>
<script>
import VueHorizontal from "vue-horizontal";
export default {
  components: {
    VueHorizontal,
  },
  props: {
    projects: Object,
  },
  methods: {
    getQuarterWithYear(date) {
      const quarter = Math.floor((new Date(date).getMonth() + 3) / 3);
      const year = new Date(date).getFullYear();
      return "Q" + quarter + " " + year;
    },
  },
};
</script>
